import React, { useState, useEffect} from 'react';
import { createUseStyles } from 'react-jss';
import { Checkbox } from 'primereact/checkbox';
import { useFormikContext, useField } from 'formik';
import { classNames } from 'primereact/utils';
import MzErrorMessage from './MzErrorMessage';
import { useRef } from 'react';

function MzFormCheckbox({ name, label, checked, onChange }) {
    const [field] = useField(name);
    const st = styles();
	const { setFieldTouched, setFieldValue, errors, touched } = useFormikContext();
	const [isChecked, setIsChecked] = useState(checked);
	
	useEffect(() => {
        setIsChecked(checked);
    }, [checked]);
	
    const handleChange = (event) => {
        setFieldValue(name, event.checked);
		setIsChecked(event.checked);
		if(onChange){
			onChange(event);
		}
		
	};

    return (
        <div className="field w-full">
            <div className="flex align-items-center">
                <Checkbox id={name} name={name} checked={isChecked} onChange={handleChange} className="mr-2"  />
                <label htmlFor={name} className="m-0" dangerouslySetInnerHTML={{ __html: label }} />
            </div>
            <MzErrorMessage error={errors[name]} visible={touched[name]} />
        </div>
    );
}

const styles = createUseStyles({
    container: {}
});

export default MzFormCheckbox;
